import { Container } from 'pixi.js';
import { Signal } from 'typed-signals';
import { playLayoutAnimation } from 'libs/layouts/layoutAnimations/playLayoutAnimation';
import { waitForMs } from 'utils/async-utils';
import { DailyRewardIconLayout } from '../../../layouts/mainMenu/home/DailyRewardIconLayout';
import type { AppStateController } from '../../app/state/AppStateController';
import type { AppState } from '../../app/state/AppState';
import type { MenuIcon } from '../types';

export class DailyRewardIconView extends Container implements MenuIcon {
  public readonly onVisibilityChanged = new Signal<(visible: boolean) => void>();

  public onClicked = new Signal();

  private readonly layout = new DailyRewardIconLayout();

  constructor(private readonly state: AppStateController) {
    super();
    this.init();
  }

  private init(): void {
    const {
      layout: { root },
    } = this;

    root.props({
      parent: this,
    });

    root.on('pointertap', () => {
      this.onClicked.emit();
    });

    this.state.subscriptions.onChange(
      ['dailyReward'],
      () => {
        this.refreshState();
      },
      this,
    );
    this.refreshState();

    this.on('destroyed', () => {
      this.state.subscriptions.removeAllSubscriptions(this);
    });
  }

  private refreshState(): void {
    this.updateNotificationAmount(this.state.getDailyRewardData());
    this.visible = this.state.hasAnyDailyRewardsToOpen();

    this.onVisibilityChanged.emit(this.visible);

    if (this.visible) {
      void this.playAttractionAnimation();
    }
  }

  public isVisible(): boolean {
    return this.visible;
  }

  private updateNotificationAmount(dailyRewardState: AppState['dailyReward']): void {
    const {
      layout: { notificationDot, notificationAmount },
    } = this;
    const amount = (dailyRewardState.freeRewardOpened ? 0 : 1) + (dailyRewardState.adRewardsOpened >= 4 ? 0 : 1);
    notificationDot.visible = amount > 0;
    notificationAmount.text = amount;
  }

  private async playAttractionAnimation(): Promise<void> {
    await playLayoutAnimation(this.layout, 'boop');
    await waitForMs(2000);
    if (!this.destroyed && this.visible) {
      void this.playAttractionAnimation();
    }
  }
}
